export default __webpack_public_path__ + "static/media/ticket.c06fda2f.svg";